module.exports = __webpack_public_path__ + "static/ontology-3002483967d60f65286807119642f6ef.png";